<template>
<!-- 血压管理 -->
  <div class="step_count_management">
    <div class="Input-Row-Top">
      <el-form>
        <el-row class="School-Effective" v-if="teacherObj.schoolId" >
          <el-col :span="5">
            <el-form-item label="学校:" label-width="80px">
              <el-select v-model="form.schoolId" placeholder="请选择数据来源" @change="schoolClick" >
                <el-option
                  :label="item.name" :value="item.id"
                  v-for="item in schoolList"
                  :key="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="年级:" label-width="80px">
              <el-select v-model="form.gradeId" placeholder="请选择数据来源" @change="classPost()">
                <el-option
                  :label="item.name" :value="item.id"
                  v-for="item in gradeList"
                  :key="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="班级:" label-width="80px" >
              <el-select v-model="form.classId" placeholder="请选择数据来源">
                <el-option
                  :label="item.name" :value="item.id"
                  v-for="item in classList"
                  :key="item.name"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="5">
            <el-form-item label="学号:" label-width="80px">
              <el-input
                v-model="form.stuNo"
                placeholder=""
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="4"> </el-col>
        </el-row>
        <el-row class="School-Effective">
          <el-col :span="5">
            <el-form-item label="IMEI:" label-width="80px">
              <el-input v-model="form.imei" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="姓名:" label-width="80px">
              <el-input v-model="form.name" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="开始时间:" label-width="80px">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="结束时间:" label-width="80px">
              <el-date-picker
                v-model="form.terminalTime"
                type="datetime"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4" class="rig_box_check">
            <el-checkbox-group v-model="form.errorFlag" @change="checkboxClick">
              <el-checkbox label="只显示异常" name="type"></el-checkbox>
            </el-checkbox-group>
           
            <el-button
              size="medium"
              type="primary"
              class="searchBtn"
              @click="searchSouSuoClick"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="export_box_r">
      <span @click="exportClick">导出数据</span>
    </div>
    <div class="table_box">
      <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style="{
          background: '#EDF6FF',
          color: '#000',
          height: '40px',
        }"
        style="width: 100%"
      >
        <el-table-column prop="imei" label="IMEI"> </el-table-column>
        <el-table-column prop="name" label="姓名"> </el-table-column>
        <el-table-column prop="stuNum" label="学号" v-if="teacherObj.schoolId" > </el-table-column>
        <el-table-column prop="schoolName" label="学校" v-if="teacherObj.schoolId" > </el-table-column>
        <el-table-column prop="gradeName" label="年级" v-if="teacherObj.schoolId" > </el-table-column>
        <el-table-column prop="className" label="班级" v-if="teacherObj.schoolId" > </el-table-column>
                <el-table-column prop="bloodX" label="收缩压"> </el-table-column>
        <el-table-column prop="statusDesL" label="高压状态">
        </el-table-column>
        <el-table-column prop="bloodY" label="舒张压"> </el-table-column>
        <el-table-column prop="statusDesR" label="低压状态">
        </el-table-column>
        <el-table-column prop="createDate" label="统计时间"> </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {healthData,healthDataExport} from '@/assets/api/api.js'
// import { findTeacherInfo } from '@/assets/api/renyuan';
import { findTeacherInfo,schoolList,gradeList,findClassList  } from '@/assets/api/renyuan';


export default {
  data() {
    return {
      form: {
        classId: "",
        gradeId: "",
        schoolId: "",
        stuNo: "",
        name: "",
        imei: "",
        startTime: "",
        terminalTime: "",
        errorFlag:[],
      },
      schoolList: [],
      gradeList :[],
      classList :[],
      tableData: [],
      total: 100,
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      teacherObj: {}
    };
  },
  created() {
    this.Lookteacher()
  },
  mounted () {
    console.log(JSON.parse(localStorage.getItem('user')).id,777777)
    this.healthData()
    this.schoolPost()
  },
  methods: {
    schoolPost() {
      let params = JSON.parse(localStorage.getItem('user')).id;
      schoolList(params).then((res) => {
        console.log(res, '学校列表');
        this.schoolList = res.data.data
      }).catch((err) => {
        console.log(err);
      })
    },
    schoolClick(){
      let params = {
        page: '1',
        pageSize: '999',
      }
        this.form.gradeId = ''
        this.form.classId = ''
      gradeList(params, this.form.schoolId).then((res) => {
        console.log(res, '年级列表', this.Dform);
        this.gradeList = res.data.data;
      }).catch((err) => {
        console.log(err);
        this.grade_loading = false;
      })
    },
    classPost(){
				let params = {
					page: '1',
					pageSize: '999',
				}
        this.form.classId = ''
				findClassList(params, this.form.gradeId).then((res) => {
					console.log(res, '班级列表');
					this.classList = res.data.data;
				}).catch((err) => {
					console.log(err);
					this.class_loading = false;;
				})
			},
    checkboxClick (val) {
      console.log('多选',val,this.form.errorFlag)
    },
    Lookteacher() {
        let params = {
          userId: JSON.parse(localStorage.getItem('user')).id,
        }
        findTeacherInfo(params).then((res) => {
          console.log(res, '查看权限');
          this.teacherObj = res.data.data
        }).catch((err) => {
        console.log(err);
        })
    },
    healthData() {
      let params = {
        classId:this.form.classId, // 班级ID
        startTime: this.form.startTime,//开始时间
        endTime: this.form.terminalTime, // 结束时间
        gradeId: this.form.gradeId, // 年级ID
        imei: this.form.imei, // 设备IMEI
        name: this.form.name, // 姓名
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        schoolId: this.form.schoolId, // 学校ID
        stuNo: this.form.stuNo, // 学号
        type: '3', // 查询类型 1 心率 2 体温 3 血压 4 血氧 5 步数
        userId: JSON.parse(localStorage.getItem('user')).id , //登录人Id
      }
      if ( this.form.errorFlag.length ) {
        params.errorFlag = 1 // 异常标识 选择时传1 不选时不传
      }         

      healthData(params).then((res)=> {
        res.data.data.list.forEach((item) => {
          // if (item)
          item.statusDesL = item.statusDes.split(" ")[0]
          item.statusDesR = item.statusDes.split(" ")[1]
        });
        this.tableData = res.data.data.list
        console.log(this.tableData,'列表')

        this.total = res.data.data.total
      })
    },
    searchSouSuoClick() {
      this.pageInfo.page = 1
      this.healthData()
      console.log("查询");
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInfo.page = val
      this.healthData()

    },
    exportClick () {
      // console.log('导出')
      let params = {
        classId:this.form.classId, // 班级ID
        startTime: this.form.startTime,//开始时间
        endTime: this.form.terminalTime, // 结束时间
        gradeId: this.form.gradeId, // 年级ID
        imei: this.form.imei, // 设备IMEI
        name: this.form.name, // 姓名
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        schoolId: this.form.schoolId, // 学校ID
        stuNo: this.form.stuNo, // 学号
        type: '3', // 查询类型 1 心率 2 体温 3 血压 4 血氧 5 步数
        userId: JSON.parse(localStorage.getItem('user')).id , //登录人Id
      }
      if ( this.form.errorFlag.length ) {
        params.errorFlag = 1 // 异常标识 选择时传1 不选时不传
      }  
      healthDataExport(params).then((res)=> {
        this.handleExport(res.data,'血压健康报表.xls')
      })
    },
    handleExport(data,name) {
      // 动态创建iframe下载文件
      let fileName = name;
      if (!data) {
          return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      console.log(blob);
      if ("download" in document.createElement("a")) {
          // 不是IE浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(url); // 释放掉blob对象
      } else {
          // IE 10+
          window.navigator.msSaveBlob(blob, fileName);
      }
    },
  },
};
</script>

<style scoped lang="scss" >
.step_count_management {
  height: 96%;
  background-color: #fff;
  overflow: auto;
  .Input-Row-Top {
    background-color: #fff;
    padding-top: 36px;
    padding-bottom: 0px;
    border-radius: 8px;
    :deep() {
      .el-form-item--small {
        margin-bottom: 40px;
      }
      .el-form-item--small .el-form-item__label {
        margin-left: 20px;
        line-height: 35px;
        font-weight: 700;
        font-size: 16px;
      }
      .el-input--small .el-input__wrapper {
        width: 10px;
        text-align: right;
        height: 35px;
        line-height: 35px;
      }
      .el-select--small .el-select__wrapper {
        height: 35px;
        // widt8h: 200px;
        max-width: 250px !important;
      }
    }
    .searchBtn {
      margin-left: 140px;
    }
    :deep(.el-button) {
      border-radius: 15px;
      padding: 10px 18px;
    }
    .rig_box_check {
      position: relative;
    }
    :deep() {
      .el-checkbox-group {
        // display: inline-block;
        position: absolute;
        left: 10px;
        top: 6px;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__label {
        font-size: 16px;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__inner {
        width: 16px;
        height: 16px;
      }
      .el-checkbox.el-checkbox--small .el-checkbox__inner:after {
        width: 4px;
        height: 8px;
      }
    }
  }
  .export_box_r {
    padding: 0px 40px;
    margin-bottom: 20px;
    color: #2440b3 ;
    cursor: pointer;
  }
  .table_box {
    padding: 0 40px;
    padding-bottom: 50px;
    position: relative;
    :deep() {
      .el-table tr {
        font-size: 16px;
        height: 40px !important;
        color: black;
      }
      .el-table--small .cell {
        text-align: center;
      }
      .textBtn {
        padding: 0px !important;
        font-size: 16px;
        // color: black;
        margin-left: 0px;
        margin-right: 5px;
      }
    }
    .block {
     position: absolute;
     bottom: 10px;
     right: 60px;
    }
  }
}
</style>